import documentLoader from "../../../utils/document-loader";
import base58 from 'base-58';

const cache = new Map<string, string>();

export async function resolvePublicKeyFromDID(
  did: string,
): Promise<string> {
    
  if (cache.has(did)) return cache.get(did)!;

  const { document } = await documentLoader(did);

  const vm = document?.verificationMethod?.find(
    (m: any) =>
      m.type === "Ed25519VerificationKey2018" ||
      m.type === "EcdsaSecp256k1VerificationKey2019"
  );

  if (!vm) throw new Error("No supported verification method");

  const key =
    vm.type === "Ed25519VerificationKey2018"
      ? Buffer.from(base58.decode(vm.publicKeyBase58)).toString("hex")
      : vm.publicKeyHex;

  cache.set(did, key);
  return key;
}